import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    StatisticsCompany, StatisticsGroup,
    StatisticsItem,
    StatisticsPagination,
    StatisticsResponse
} from "features/model/types/hr/getStatistics";


export interface StatisticsFilters {
    from: string;
    to: string;
    group_id: number | null;
}

export interface IStatisticsResponse {
    success: boolean;
    isLoading:boolean;
    data: {
        count: number;
        groups:StatisticsGroup[];
        company: StatisticsCompany;
        items: StatisticsItem[];
        pagination: StatisticsPagination;
    };
    filters: StatisticsFilters;
}


const initialState: IStatisticsResponse = {
    success: false,
    isLoading: true,
    data: {
        groups: [],
        count: 0,
        company: { id: 0, title: '' },
        items: [],
        pagination: { page: 0, pageSize: 0, pageCount: 0 },
    },
    filters: {
        from: '',
        to: '',
        group_id: null,
    },
};


const statisticsSlice = createSlice({
    name: 'statistics',
    initialState,
    reducers: {
        setStatisticsData: (state, action: PayloadAction<StatisticsResponse['data']>) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setStatisticsFilters: (
            state,
            action: PayloadAction<Partial<StatisticsFilters>>
        ) => {
            state.filters = {
                ...state.filters,
                ...action.payload,
            };
        },
    },
});


export const { setStatisticsData, setLoading, setStatisticsFilters } = statisticsSlice.actions;
export const statisticsReducer = statisticsSlice.reducer;
